export default __webpack_public_path__ + "static/media/welcome_bg_top.42ecf7da.png";